import { getPromptHistorySubmissionEvent, isPromptHistorySelectionActive, navigatePromptHistorySelection, preparePromptHistoryValues, } from '#pplx/frontend/composer-sdk-plugins/prompt-history/promptHistoryMechanics.js';
import { createPlainTextComposerValue } from '#pplx/frontend/composer-sdk/createPlainTextComposerValue.js';
import { serializedStateToPlainText } from '#pplx/frontend/composer-sdk/serializedStateToPlainText.js';
export const EMPTY_PROMPT_HISTORY_STATE = {
    selectedIndex: null,
    ownedPlainText: null,
    detached: false,
};
const EMPTY_COMPOSER_VALUE = createPlainTextComposerValue('');
/**
 * Normalizes newest-first consumer history for navigation.
 *
 * Removes blanks and adjacent plain-text duplicates up to the history limit,
 * preserving the original rich serialized values.
 */
export function preparePromptHistory(history) {
    return preparePromptHistoryValues(history, serializedStateToPlainText);
}
/**
 * Navigates history in the requested up or down direction without taking over user-edited drafts.
 *
 * Navigation starts only from an empty draft or a still-unedited replacement previously returned
 * by this function. A handled result may include the serialized replacement and a telemetry event.
 */
export function navigatePromptHistory({ currentValue, direction, history, state, }) {
    const currentPlainText = serializedStateToPlainText(currentValue);
    const currentState = currentPlainText === '' ? EMPTY_PROMPT_HISTORY_STATE : state;
    const isOwnedDraft = isPromptHistorySelectionActive(currentState) &&
        currentState.ownedPlainText === currentPlainText;
    const selectedIndex = navigatePromptHistorySelection(direction, history.length, currentState, currentPlainText === '' || isOwnedDraft);
    if (selectedIndex === undefined)
        return { handled: false, state: currentState };
    const replacement = selectedIndex === null ? EMPTY_COMPOSER_VALUE : history[selectedIndex];
    if (replacement === undefined)
        return { handled: false, state: currentState };
    return {
        handled: true,
        replacement,
        state: selectedIndex === null
            ? EMPTY_PROMPT_HISTORY_STATE
            : {
                selectedIndex,
                ownedPlainText: serializedStateToPlainText(replacement),
                detached: false,
            },
        event: { action: 'navigate', direction, selectedIndex, historySize: history.length },
    };
}
/** Resets navigation after submission and reports when the submitted draft came from history. */
export function acceptPromptHistorySubmission(state, historySize, currentValue) {
    const event = getPromptHistorySubmissionEvent(state, historySize, isPromptHistorySelectionActive(state) &&
        state.ownedPlainText === serializedStateToPlainText(currentValue));
    return { state: EMPTY_PROMPT_HISTORY_STATE, ...(event === undefined ? {} : { event }) };
}
//# sourceMappingURL=promptHistoryState.js.map